export const ROUND_INTERMISSION_MS = 5_000;

export function roundTransitionState(deadline: number | null, now: number): {
  progress: number;
  seconds: number;
} {
  const remaining = deadline === null
    ? ROUND_INTERMISSION_MS
    : Math.max(0, Math.min(ROUND_INTERMISSION_MS, deadline - now));
  return {
    progress: Math.min(100, Math.max(0, ((ROUND_INTERMISSION_MS - remaining) / ROUND_INTERMISSION_MS) * 100)),
    seconds: Math.ceil(remaining / 1_000)
  };
}
